import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import alertGiftImg from '@/assets/landing/alert-gift.png'
import taiChiGolf40Img from '@/assets/landing/tai-chi-golf-40.png'
import taiChiGolf50Img from '@/assets/landing/tai-chi-golf-50.png'
import taiChiGolf70Img from '@/assets/landing/tai-chi-golf-70.png'
import taiChiGolf60Img from '@/assets/landing/tai-chi-golf-60.png'

const schema: LandingScreenSchema = {
	order: ['LandingAlert', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingAlert: ({ $t }): LandingComponentsConfig['LandingAlert'] => ({
			text: $t('female_yoga.pages.landing.alert_text'),
			icon: alertGiftImg,
			backgroundColor: 'var(--Fill-Accent-16)',
			customStyles: {
				marginTop: 'var(--size-20)',
			},
		}),

		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Tai Chi for GOLFERS',
			size: 'large',
			uppercase: true,
			customStyles: {
				marginTop: '2rem',
				marginBottom: '0.625rem',
			},
		}),

		LandingSubtitle: (): LandingComponentsConfig['LandingSubtitle'] => ({
			title: '1-minute quiz',
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'blue',
			ageRanges: [
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_yoga.pages.landing.age_range.40_49'),
					img: taiChiGolf40Img,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_yoga.pages.landing.age_range.50_59'),
					img: taiChiGolf50Img,
				},
				{
					value: 60,
					analyticValue: '60-69',
					label: $t('female_yoga.pages.landing.age_range.60_69'),
					img: taiChiGolf70Img,
				},
				{
					value: 70,
					analyticValue: '70+',
					label: $t('female_yoga.pages.landing.age_range.70_80'),
					img: taiChiGolf60Img,
				},
			],
			otherAgesButton: {
				data: { value: 18, analyticValue: '18-39' },
				text: $t('female_yoga.pages.landing.im_young'),
			},
		}),
	},
}

export default schema
